import * as _ from 'lodash';

import { RECEIVE_USER_PROFILES, REQUEST_USER_PROFILES, UserProfileAction } from '@Actions/userProfilesActions';

import { IUserProfileModel } from '@Shared/models';

interface IUserProfilesState {
  loading: boolean;
  invitedProfiles: IUserProfileModel[];
  activeProfiles: IUserProfileModel[];
  inactiveProfiles: IUserProfileModel[];
}

const defaultState: IUserProfilesState = {
  loading: false,
  invitedProfiles: [],
  activeProfiles: [],
  inactiveProfiles: []
};

export const userProfilesReducer = function (state = defaultState, action: UserProfileAction) {
  switch (action.type) {
    case REQUEST_USER_PROFILES:
      return _.assign({}, state, {
        loading: true
      });
    case RECEIVE_USER_PROFILES:
      return _.assign({}, state, {
        loading: false,
        invitedProfiles: [...action.invitedProfiles],
        activeProfiles: [...action.activeProfiles],
        inactiveProfiles: [...state.inactiveProfiles]
      });
    default:
      return state;
  }
};
